import React, { useState } from 'react';
import { BiDetail, BiMenuAltRight } from 'react-icons/bi';
import { FiDollarSign } from 'react-icons/fi';
import { MdChevronLeft } from 'react-icons/md';
import { RiHistoryFill } from 'react-icons/ri';
import { useLocation, useHistory } from 'react-router-dom';
import { BsChatSquareText, BsPrinter, BsShieldExclamation } from 'react-icons/bs';
import { Container, ItemMenu, TextItem, Div, Subtitle, ModalButton, Description, MobileMenu } from './styles';
import { Dialog, Button } from 'components';
import { VscCloseAll } from 'react-icons/vsc';
import { BiBarcodeReader } from 'react-icons/bi';
import { IoWalletOutline } from 'react-icons/io5';
import { toast } from 'react-toastify';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import api from 'api';
import Cookies from 'js-cookie';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import settings from 'settings.json';

function BackofficeMenu({ policyId, onCancel, policyData, loadData, hasProducts }) {
  const location = useLocation();
  const path = location.pathname;
  const history = useHistory();

  const rootPath = path.includes('/comercial') ? '/comercial' : '/backoffice';

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [textInput, setTextInput] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [substatus, setSubstatus] = useState('');

  const handleCancelPolicy = async (e) => {
    setLoadingCancel(true);
    try {
      await api({
        method: 'POST',
        url: `/backoffice-cancel-policy`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
        data: {
          id: policyId,
          description: textInput,
          substatus: substatus,
        },
        json: true,
      });

      toast.success('Contrato cancelado com sucesso', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } catch (e) {
      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      loadData();
      setLoadingCancel(false);
      handleClose();
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MobileMenu>
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
          <BiMenuAltRight size={26} />
        </IconButton>

        <Menu
          style={{ marginTop: '50px', marginLeft: '-40px' }}
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => {
              rootPath === '/comercial' ? history.push('/comercial/meus-contratos') : history.push('/backoffice/contratos');
            }}
          >
            <MdChevronLeft size="18" />
            <TextItem>Contratos</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes(`${rootPath}/detalhes-do-contrato`)}
            onClick={() => {
              history.push(`${rootPath}/detalhes-do-contrato/${policyId}`);
            }}
          >
            <BiDetail size="18" />
            <TextItem>Detalhes</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes(`${rootPath}/historico-do-contrato`)}
            onClick={() => {
              history.push(`${rootPath}/historico-do-contrato/${policyId}`);
            }}
          >
            <RiHistoryFill size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Histórico do contrato</TextItem>
          </MenuItem>

          <ItemMenu
            onClick={() => {
              history.push(`${rootPath}/listar-documentos-contratos/${policyId}`);
            }}
          >
            <BsPrinter size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Imprimir</TextItem>
          </ItemMenu>

          {hasProducts && (
            <ItemMenu
              onClick={() => {
                window.open(`${rootPath}/detalhes-do-contrato/${policyId}/imprimir-documento-complementar`, '_blank');
              }}
            >
              <BsPrinter size="18" style={{ marginRight: '-3px' }} />
              <TextItem>Documento complementar</TextItem>
            </ItemMenu>
          )}

          <MenuItem
            selected={path.includes(`${rootPath}/faturas`)}
            onClick={() => {
              history.push(`${rootPath}/faturas/${policyId}`);
            }}
          >
            <FiDollarSign size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Faturas</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes(`${rootPath}/historico-reclamacao`)}
            onClick={() => {
              history.push(`${rootPath}/historico-reclamacao/${policyId}`);
            }}
          >
            <BsChatSquareText size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Reclamações</TextItem>
          </MenuItem>

          {policyData?.status === 'active' && (
            <MenuItem onClick={onCancel}>
              <VscCloseAll size="18" style={{ marginRight: '-3px' }} />
              <TextItem onClick={handleClickOpen}>Cancelar seguro</TextItem>

              <>
                <Dialog
                  open={open}
                  title="Confirmar cancelamento"
                  width="450px"
                  onConfirm={handleCancelPolicy}
                  onCancel={handleClose}
                  loading={loading}
                >
                  <Div>
                    <Subtitle>Tem certeza de que deseja cancelar este contrato? O cancelamento não poderá ser desfeito!</Subtitle>
                    <Description>
                      <TextareaAutosize
                        minRows={1}
                        onChange={(e) => setTextInput(e.target.value)}
                        value={textInput}
                        placeholder="Observações..."
                        style={{
                          padding: 10,
                          fontFamily: 'Nunito',
                          fontSize: 14,
                          marginTop: '3%',
                          width: '100%',
                          height: '100px',
                          borderRadius: 5,
                          borderColor: '#d1d2d4',
                        }}
                      />
                    </Description>
                  </Div>
                  <ModalButton>
                    <Button
                      height="35px"
                      style={{ background: 'transparent', border: '1.5px solid #62ec83' }}
                      onClick={handleClose}
                    >
                      Voltar
                    </Button>
                    <Button
                      height="35px"
                      style={{ background: '#62ec83', border: 'none' }}
                      onClick={handleCancelPolicy}
                      loading={loadingCancel}
                    >
                      Concluir cancelamento
                    </Button>
                  </ModalButton>
                </Dialog>
              </>
            </MenuItem>
          )}

          <MenuItem onClick={() => window.open(settings?.claim_url)}>
            <BsShieldExclamation size="18" style={{ marginRight: '-3px' }} />
            <TextItem onClick={handleClickOpen}>Comunicar sinistro</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes(`${rootPath}/extrato`)}
            onClick={() => {
              history.push(`${rootPath}/extrato/${policyId}`);
            }}
          >
            <BsChatSquareText size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Extrato</TextItem>
          </MenuItem>
        </Menu>
      </MobileMenu>

      <Container>
        <ItemMenu
          onClick={() => {
            rootPath === '/comercial' ? history.push('/comercial/meus-contratos') : history.push('/backoffice/contratos');
          }}
        >
          <MdChevronLeft size="18" />
          <TextItem>Contratos</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes(`${rootPath}/detalhes-do-contrato`) && 'select'}
          onClick={() => {
            history.push(`${rootPath}/detalhes-do-contrato/${policyId}`);
          }}
        >
          <BiDetail size="18" />
          <TextItem>Detalhes</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes(`${rootPath}/historico-do-contrato`) && 'select'}
          onClick={() => {
            history.push(`${rootPath}/historico-do-contrato/${policyId}`);
          }}
        >
          <RiHistoryFill size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Histórico do contrato</TextItem>
        </ItemMenu>

        <ItemMenu
          onClick={() => {
            history.push(`${rootPath}/listar-documentos-contrato/${policyId}`);
          }}
        >
          <BsPrinter size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Imprimir contrato</TextItem>
        </ItemMenu>

        {hasProducts && (
          <ItemMenu
            onClick={() => {
              window.open(`${rootPath}/detalhes-do-contrato/${policyId}/imprimir-documento-complementar`, '_blank');
            }}
          >
            <BsPrinter size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Imprimir documento complementar</TextItem>
          </ItemMenu>
        )}

        <ItemMenu
          className={path.includes(`${rootPath}/faturas`) && 'select'}
          onClick={() => {
            history.push(`${rootPath}/faturas/${policyId}`);
          }}
        >
          <FiDollarSign size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Faturas</TextItem>
        </ItemMenu>
        <ItemMenu
          className={path.includes(`${rootPath}/historico-reclamacao`) && 'select'}
          onClick={() => {
            history.push(`${rootPath}/historico-reclamacao/${policyId}`);
          }}
        >
          <BsChatSquareText size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Reclamações</TextItem>
        </ItemMenu>

        {policyData?.status === 'active' && policyData?.claim_notice !== true && (
          <ItemMenu onClick={onCancel}>
            <VscCloseAll size="18" style={{ marginRight: '-3px' }} />
            <TextItem onClick={handleClickOpen}>Cancelar seguro</TextItem>

            <>
              <Dialog
                open={open}
                title="Confirmar cancelamento"
                width="450px"
                onConfirm={handleCancelPolicy}
                onCancel={handleClose}
                loading={loading}
              >
                <Div>
                  <Subtitle>Tem certeza de que deseja cancelar este contrato? O cancelamento não poderá ser desfeito!</Subtitle>
                  Atenção: Para propostas com data de ativação igual ou menor que sete dias a vigência do contrato será cancelada,
                  caso contrario ao contrato fica ativa somente até a próxima data de resubscrição.
                  <Description>
                    <TextareaAutosize
                      minRows={1}
                      maxLength={100}
                      onChange={(e) => setTextInput(e.target.value)}
                      value={textInput}
                      placeholder="Descreva o motivo do cancelamento"
                      style={{
                        padding: 10,
                        fontFamily: 'Nunito',
                        fontSize: 14,
                        marginTop: '3%',
                        width: '100%',
                        height: '100px',
                        borderRadius: 5,
                        borderColor: '#d1d2d4',
                      }}
                    />
                  </Description>
                </Div>
                <ModalButton>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'space-between',
                      gap: '15px',
                      width: '100%',
                      marginTop: '3%',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '6px' }}>
                      <label style={{ fontFamily: 'Nunito', fontSize: 11, marginLeft: '8px' }}>Motivos</label>
                      <select
                        value={substatus}
                        onChange={(e) => setSubstatus(e.target.value)}
                        style={{
                          height: '35px',
                          width: '75%',
                          borderRadius: 12,
                          borderColor: '#d1d2d4',
                          marginBottom: '8px',
                        }}
                      >
                        <option value="">Selecione...</option>
                        <option value="customer_request">Desistiu do seguro</option>
                        <option value="commercial_dissatisfaction">Insatisfação comercial</option>
                        <option value="financial_difficulty">Sem condições financeiras</option>
                        <option value="vehicle_replacement">Substituição de veículo</option>
                        <option value="total_loss">Veículo indenizado</option>
                        <option value="vehicle_sold">Veículo vendido</option>
                      </select>
                    </div>
                    <Button
                      height="35px"
                      style={{ background: 'transparent', border: '1.5px solid #62ec83' }}
                      onClick={handleClose}
                    >
                      Voltar
                    </Button>

                    <Button
                      height="35px"
                      style={{ background: '#62ec83', border: 'none' }}
                      disabled={!substatus}
                      onClick={handleCancelPolicy}
                      loading={loadingCancel}
                    >
                      Concluir cancelamento
                    </Button>
                  </div>
                </ModalButton>
              </Dialog>
            </>
          </ItemMenu>
        )}

        <ItemMenu onClick={() => window.open(settings?.claim_url)}>
          <BsShieldExclamation size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Comunicar sinistro</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes(`${rootPath}/historico-extrato`) && 'select'}
          onClick={() => {
            history.push(`${rootPath}/historico-extrato/${policyId}`);
          }}
        >
          <FiDollarSign size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Extrato</TextItem>
        </ItemMenu>
      </Container>
    </>
  );
}

export default BackofficeMenu;
